<template>
    <div>
        <xx-select
            v-model="model"
            v-bind="$attrs"
            :list="innerList"
            v-on="$listeners"
            @change="change"
        />
    </div>
</template>

<script>
export default {
    name: 'ByParentSelect',
    props: {
        value: {
            type: [String, Number, Array],
            required: true,
        },
        byType: {
            type: String,
            default: '',
        },
        byIdName: {
            type: String,
        },
        params: {
            type: Object,
            default: () => ({}),
        },
        apiConfig: {
            type: Object,
            default: () => ({}),
        },
        buildParams: {
            type: Function,
            default: (v) => v,
        },
        formatResponseData: {
            type: Function,
            default: (v) => v,
        },
    },
    data() {
        return {
            model: this.value,
            innerList: [],
        };
    },
    watch: {
        value: {
            handler(v) {
                this.model = v;
            },
            deep: true,
        },
        params: {
            handler() {
                this.innerGetList();
            },
            deep: true,
        },
    },
    created() {
        this.innerGetList();
    },
    methods: {
        innerGetList() {
            if (this.byType === 'byId') {
                if (this.params[this.byIdName]) {
                    this.getList();
                }
            } else {
                this.getList();
            }
        },
        change(v, item) {
            const obj = this.innerList.find(
                (i) => (i[this.$attrs.valueKey] === v || i.value === v),
            );
            this.$emit('input', v);
            this.$emit('change', v, item, obj || {});
        },
        async getList() {
            let res = [];
            const { type, url, params } = this.apiConfig;
            const { buildParams } = this;
            const requsetParams = { ...params, ...this.params };
            res = await this[`$${type}`](url, buildParams(requsetParams));
            this.innerList = this.formatResponseData(res || []);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
